module.exports = __webpack_public_path__ + "img/HZ-B5003.e2c3375d.jpg";